/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import { IMenuLanguageSelectedOption } from './IMenuLanguageSelectedOption';
import {
    SET_MENU_LANGUAGE_OPTIONS_LIST,
    SET_MENU_LANGUAGE_SELECTED_OPTION,
} from './userprefmenulanguage.types';

export const setMenuLanguageOptionsListAction = (
    optionsList: Array<IMenuLanguageSelectedOption>,
): TivoPayloadAction<{
    optionsList: Array<IMenuLanguageSelectedOption>;
}> => ({
    type: SET_MENU_LANGUAGE_OPTIONS_LIST,
    payload: { optionsList },
});

export const setSelectedMenuLanguageOptionAction = (
    selectedOption?: IMenuLanguageSelectedOption,
): TivoPayloadAction<{ selectedOption?: IMenuLanguageSelectedOption }> => ({
    type: SET_MENU_LANGUAGE_SELECTED_OPTION,
    payload: { selectedOption },
});
